import React from "react";
import ArrowTrainer from "./ArrowTrainer";

const DIRECTIONS_8 = [
  "up",
  "down",
  "left",
  "right",
  "up-right",
  "up-left",
  "down-right",
  "down-left",
];

export default function Arrows8Page() {
  return (
    <ArrowTrainer
      directions={DIRECTIONS_8}
      titleKey="arrowsDiag"
      accent="orange"
      testid="arrows-diag-page"
    />
  );
}
